import React from 'react';
import { ArrowRight } from 'lucide-react';
import { hasValidHTMLContent } from '@/utils/html-content';

interface EmailPreviewProps {
  reportTitle: string;
  subject: string;
  body: string;
}

export const EmailPreview: React.FC<EmailPreviewProps> = ({
  reportTitle,
  subject,
  body,
}) => {
  const hasBody = hasValidHTMLContent(body);
  const trimmedSubject = subject.trim();

  return (
    <div className="flex w-full min-w-0 flex-1 flex-col overflow-hidden rounded-md border border-[#E5E5E5] bg-white">
      <div className="flex items-center bg-[linear-gradient(0deg,rgba(255,255,255,0.5),rgba(255,255,255,0.5)),#F5F5F5] px-4 py-3">
        <div className="flex min-w-0 flex-1 flex-col gap-0.5">
          <p className="font-sans text-sm font-normal leading-5 text-[#737373]">
            Prévia do e-mail para o report:
          </p>
          <p className="truncate font-sans text-base font-semibold leading-6 text-[#0A0A0A]">
            {reportTitle}
          </p>
        </div>
      </div>

      <div className="flex flex-1 flex-col gap-4 p-4">
        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-2">
            <p className="font-sans text-sm font-normal leading-5 text-[#737373]">
              Assunto
            </p>
            <p
              className={
                trimmedSubject
                  ? 'font-sans text-sm font-semibold leading-5 text-[#0A0A0A]'
                  : 'font-sans text-sm font-normal leading-5 text-[#737373]'
              }
            >
              {trimmedSubject || 'O assunto do e-mail aparecerá aqui...'}
            </p>
          </div>
          <div className="py-1">
            <div className="h-px w-full bg-[#E5E5E5]" />
          </div>
        </div>

        {hasBody ? (
          <div
            className="email-preview-body flex-1 font-sans text-sm font-normal leading-5 text-[#737373]"
            dangerouslySetInnerHTML={{ __html: body }}
          />
        ) : (
          <p className="flex-1 font-sans text-sm font-normal leading-5 text-[#737373]">
            O conteúdo do e-mail aparecerá aqui...
          </p>
        )}

        <button
          type="button"
          tabIndex={-1}
          className="pointer-events-none flex h-9 w-full items-center justify-center gap-2 rounded-lg bg-[#F5F5F5] px-4 text-sm font-medium leading-5 text-[#171717]"
        >
          Ver report completo
          <ArrowRight className="h-4 w-4" strokeWidth={1.33} aria-hidden />
        </button>
      </div>

      <style>{`
        .email-preview-body ul, .email-preview-body ol { padding-left: 1.5rem; margin: 0.5rem 0; }
        .email-preview-body ul { list-style-type: disc; }
        .email-preview-body ol { list-style-type: decimal; }
        .email-preview-body p { margin: 0.75rem 0; }
        .email-preview-body p:first-child { margin-top: 0; }
        .email-preview-body p:last-child { margin-bottom: 0; }
      `}</style>
    </div>
  );
};
